var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellerProfileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_932_2885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.5 256C509.96 341.47 494.95 410.21 451.92 451.92C410.21 494.95 341.47 509.96 256 511.5C170.53 509.96 101.79 494.95 60.08 451.92C17.05 410.21 2.04 341.47 0.5 256C2.04 170.53 17.05 101.79 60.08 60.08C101.79 17.05 170.53 2.04 256 0.5C341.47 2.04 410.21 17.05 451.92 60.08C494.95 101.79 509.96 170.53 511.5 256Z",
    fill: "url(#paint0_linear_932_2885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5 256C509.96 341.47 494.95 410.21 451.92 451.92C410.21 494.95 341.47 509.96 256 511.5C170.53 509.96 101.79 494.95 60.08 451.92C17.05 410.21 2.04 341.47 0.5 256C2.04 170.53 17.05 101.79 60.08 60.08C101.79 17.05 170.53 2.04 256 0.5C341.47 2.04 410.21 17.05 451.92 60.08C494.95 101.79 509.96 170.53 511.5 256Z",
    fill: "url(#paint1_radial_932_2885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73 241.25C299.443 241.25 335.69 205.003 335.69 160.29C335.69 115.577 299.443 79.3301 254.73 79.3301C210.017 79.3301 173.77 115.577 173.77 160.29C173.77 205.003 210.017 241.25 254.73 241.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5 373.19C393.5 396.72 374.43 415.8 350.89 415.8H161.11C137.58 415.8 118.5 396.73 118.5 373.19L118.56 349.39C120.27 316 147.03 287.03 186.31 271.11C191.06 269.18 196.4 269.49 201.02 271.72C217.26 279.56 235.48 283.96 254.72 283.96C274.35 283.96 292.92 279.38 309.41 271.24C314 268.97 319.33 268.62 324.1 270.5C364.24 286.29 391.71 315.62 393.43 349.46L393.5 373.19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_2885",
    x1: 58.426,
    y1: 58.426,
    x2: 451.75,
    y2: 451.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DBAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#6FAEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#4DA0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#409BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_932_2885",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.461 45.499) scale(319.547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2DEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_2885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerProfileImage);
export default __webpack_public_path__ + "static/media/sellerProfileImage.2a565e85b62483c6f7751bdcecbf390d.svg";
export { ForwardRef as ReactComponent };